export const searchLabel2Value = {
  人选: '人选',
  公司: '公司',
  项目: '项目',
  资源库: '文件',
  薪酬: '薪酬',
  行业薪酬: '行业薪酬',
}
export const searchPlaceHolder = {
  人选: '请输入关键词，多个关键词之间请用空格空开',
  公司: '请输入公司名称',
  项目: '请输入项目名称',
  资源库: '请输入内容',
  薪酬: '请输入公司名称',
}
// export const checkHasValue = (obj = {}, fields = []) => {
//   let hasValue = false
//   for (const field of fields) {
//     const value = obj[field]
//     if (!value) continue
//     if (typeof value !== 'object') {
//       hasValue = true
//       break
//     } else if (Array.isArray(value) && value.length > 0) {
//       hasValue = true
//       break
//     } else {
//       // eslint-disable-next-line no-loop-func
//       Object.keys(value).forEach(v => {
//         const objValue = value[v]
//         if (Array.isArray(objValue) && objValue.length > 0) {
//           hasValue = true
//         } else if (!Array.isArray(objValue) && objValue) hasValue = true
//       })
//     }
//   }
//   return hasValue
// }
